"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var VideoCameraDisabledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M5.86678246,3.16006254 L5.92183074,3.23156225 L12.9218307,14.2315623 C13.0700848,14.4645329 13.0014084,14.7735767 12.7684377,14.9218307 C12.5613527,15.0536121 12.2941605,15.0139917 12.1332175,14.8399375 L12.0781693,14.7684377 L5.07816926,3.76843775 C4.92991518,3.53546706 4.99859157,3.22642333 5.23156225,3.07816926 C5.43864731,2.94638786 5.70583946,2.9860083 5.86678246,3.16006254 Z M4.69131731,5.0236757 L5.312,5.99991021 L5,6 C4.44771525,6 4,6.44771525 4,7 L4,12 C4,12.5522847 4.44771525,13 5,13 L9.767,12.9999102 L10.403,13.9999102 L5,14 C3.8954305,14 3,13.1045695 3,12 L3,7 C3,6.00041025 3.73331299,5.17209492 4.69131731,5.0236757 Z M8.232,4.99991021 L11,5 C12.1045695,5 13,5.8954305 13,7 L13,7.56853512 L15.3528027,6 L16,6 L16,13.0027937 L15.3230898,13.0045969 L13,11.4417743 L13,12 C13,12.1443033 12.9847174,12.2850371 12.9556823,12.4206712 L12,10.9209102 L12,10 L12.6525318,10 L15,11.5792227 L15,7.43425855 L12.6513878,9 L12,9 L12,7 C12,6.44771525 11.5522847,6 11,6 L8.868,5.99991021 L8.232,4.99991021 Z" })));
};
VideoCameraDisabledSmall.displayName = 'VideoCameraDisabledSmall';
exports.default = VideoCameraDisabledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=VideoCameraDisabledSmall.js.map